module.exports = __webpack_public_path__ + "img/desktop.d443f9fb.png";